import { object, string } from "yup";

export const validationSchema = object({
  email: string()
    .required("Email cannot be empty")
    .email("Email has invalid format"),
  password: string().required("Password is required"),
});
